import script from "./KPISection.vue?vue&type=script&setup=true&lang=js"
export * from "./KPISection.vue?vue&type=script&setup=true&lang=js"

import "./KPISection.vue?vue&type=style&index=0&id=a09a64ca&lang=scss&scoped=true"

import exportComponent from "/Users/pontiroli/Desktop/Repositories/eni/dist/eni-dist-eni-for-2022-hub-e-longform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a09a64ca"]])

export default __exports__